import { Link, useNavigate } from "react-router-dom";

// mui import
import { MenuItem } from "react-pro-sidebar";
import { Tooltip, Typography, useTheme } from "@mui/material";
import "react-pro-sidebar/dist/css/styles.css";

// project import
import { tokens } from "../../theme";

const Item = ({ title, to, icon, selected, setSelected, style = {} }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();

  const handleClick = (e) => {
    // Prevent default link behavior
    e.preventDefault();
    
    // Don't handle click if no 'to' prop (for dummy items)
    if (!to) {
      return;
    }
    
    // Set selected item
    if (setSelected) {
      setSelected(title);
    }
    
    // Navigate using React Router
    navigate(to);
  };

  return (
    <Tooltip title={title}>
    <MenuItem
      active={selected === title}
      style={{
        color: colors.grey[100],
        ...style, // Apply custom styles
      }}
      onClick={handleClick}
      icon={icon}
    >
      <Typography>{title}</Typography>
      {to && <Link to={to} />}
    </MenuItem>
    </Tooltip>
  );
};

export default Item;